
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-policies",
      function () {
        return require("private-next-pages/our-policies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-policies"])
      });
    }
  